module.exports = __webpack_public_path__ + "static/img/1048_big.dedd661.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1048_big.png
// module id = 8c/q
// module chunks = 1